// extracted by mini-css-extract-plugin
export default {"errorContainer":"errorpage_errorContainer__DyogQ","errorHeader":"errorpage_errorHeader__jlOy3","errorText":"errorpage_errorText__YAr93","link":"errorpage_link__9w4xq"};